import { useRef } from "react";
import "../styles/latestRelease.css";

const movies = [
  { id: 1, title: "Skyscraper", year: "2018", img: "/letestrelesebanner/1.jpg" },
  { id: 2, title: "Hunting Party", year: "2024", img: "/letestrelesebanner/2.jpg" },
  { id: 3, title: "The Pitt", year: "2025", img: "/letestrelesebanner/3.jpg" },
  { id: 4, title: "Deshpande", year: "2025", img: "/letestrelesebanner/4.jpg" },
  { id: 5, title: "Aaromaley", year: "2024", img: "/letestrelesebanner/5.jpg" },
  { id: 6, title: "Naagin", year: "2023", img: "/letestrelesebanner/6.jpg" },
  { id: 7, title: "Uppu Puli", year: "2022", img: "/letestrelesebanner/7.jpg" },
  { id: 8, title: "Movie X", year: "2021", img: "/letestrelesebanner/1.png" },
  { id: 9, title: "Movie Y", year: "2020", img: "/letestrelesebanner/3.png" },
  { id: 10, title: "Movie Z", year: "2019", img: "/letestrelesebanner/4.png" }
];

export default function LatestReleaseRow() {

  const rowRef = useRef();

  return (
    <div className="latestWrap">

      {/* HEADER */}
      <div className="rowHeader">
        <h2>Latest Releases</h2>
        <span className="viewAll">View All</span>
      </div>

      {/* SLIDER */}
      <div className="sliderWrap">

        <div
          className="navArrow"
          onClick={() => rowRef.current.scrollLeft -= 400}
        >❮</div>

        <div className="latestRow" ref={rowRef}>
          {movies.map((m) => (
            <div
              key={m.id}
              className="movieCard"
              tabIndex="0"
            >
              <img src={m.img} />

              <div className="movieInfo">
                <h4>{m.title}</h4>
                <p>{m.year} • Action • Thriller</p>
                <button>▶ Watch Now</button>
              </div>
            </div>
          ))}
        </div>

        <div
          className="navArrow"
          onClick={() => rowRef.current.scrollLeft += 400}
        >❯</div>

      </div>
    </div>
  );
}
